export default "__VITE_ASSET__ChCzzjNX__"